/* global axios */

import ApiClient from './ApiClient';

class DashboardAppsAPI extends ApiClient {
  constructor() {
    super('dashboard_apps', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new DashboardAppsAPI();
